export const postRouts = {
  root: '/posts',
  post: '/posts/:id',
};
